import { useUpdateUserSettings } from 'features/user';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Calendar,
  CheckCircle,
  Repeat,
  SettingsSort18,
} from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { useUser } from 'shared/hooks/use-user';

export const FilterButton: React.FC = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();

  const toggleHideHabits = () =>
    updateUserSettings({
      calendar: {
        hideHabits: !user?.settings?.calendar?.hideHabits,
      },
    });
  const toggleHideExternalCalendars = () =>
    updateUserSettings({
      calendar: {
        hideExternalCalendarEvents:
          !user?.settings?.calendar?.hideExternalCalendarEvents,
      },
    });
  const toggleHideCompletedTasks = () =>
    updateUserSettings({
      calendar: {
        hideCompletedTasks: !user?.settings?.calendar?.hideCompletedTasks,
      },
    });

  return (
    <>
      <IconButton
        icon={SettingsSort18}
        ref={buttonRef}
        onClick={openMenu}
        color={Colors.Default}
        preventDrag
      />

      {menuOpen && (
        <PopupMenu referenceElement={buttonRef} onOutside={closeMenu}>
          <PopupMenuList>
            <PopupMenuListItem>
              <PopupMenuToggle
                start={<Icon icon={Repeat} />}
                label={t('pages.today.side-panel.settings.habits.show.label')}
                onChange={toggleHideHabits}
                checked={!user?.settings?.calendar?.hideHabits}
              />
            </PopupMenuListItem>
            <PopupMenuListItem>
              <PopupMenuToggle
                start={<Icon icon={Calendar} />}
                label={t(
                  'pages.today.side-panel.settings.external-calendars.show.label',
                )}
                onChange={toggleHideExternalCalendars}
                checked={!user?.settings?.calendar?.hideExternalCalendarEvents}
              />
            </PopupMenuListItem>
            <PopupMenuListItem>
              <PopupMenuToggle
                start={<Icon icon={CheckCircle} />}
                label={t(
                  'pages.today.side-panel.settings.completed-tasks.show.label',
                )}
                onChange={toggleHideCompletedTasks}
                checked={!user?.settings?.calendar?.hideCompletedTasks}
              />
            </PopupMenuListItem>
          </PopupMenuList>
        </PopupMenu>
      )}
    </>
  );
};
